/* Lucky Number 24 — Browse Numbers: compact smart filter bar
   Replaces the big filter panel with one row of dropdowns (Price / Pattern / Good sum / Sort),
   live match counts, removable "active filter" chips and a Clear button. */
(function(){
  if(!document.getElementById('ln24-browse'))return;
  var S={good:false,ready:false};
  var SORTS=[['recommended','Recommended'],['lucky','Luckiest first'],['price-asc','Price: low to high'],['price-desc','Price: high to low']];
  var PRICES=[['0-124','Under $100'],['125-249','$100 – $199'],['250-499','$200 – $399'],['500-999999','$400+']];
  var PAT_LABEL={'repeating':'Repeating','ascending':'Ascending','descending':'Descending','mirror':'Mirror','lucky-8':'Lucky 8','quad0':'Ends 0000'};
  function $(id){return document.getElementById(id);}
  function el(tag,cls,html){var e=document.createElement(tag);if(cls)e.className=cls;if(html!=null)e.innerHTML=html;return e;}
  function live(){return window.LN24B_LIVE||[];}

  function dropdown(key,icon,title){
    var wrap=el('div','ln24f-dd');wrap.setAttribute('data-key',key);
    var btn=el('button','ln24f-btn','<span class="ic">'+icon+'</span><span class="lb">'+title+'</span><span class="car">▾</span>');
    btn.type='button';btn.setAttribute('aria-haspopup','true');btn.setAttribute('aria-expanded','false');
    var pop=el('div','ln24f-pop');
    btn.addEventListener('click',function(e){e.stopPropagation();var open=!wrap.classList.contains('open');closeAll();if(open){wrap.classList.add('open');btn.setAttribute('aria-expanded','true');if(window.innerWidth<=760){document.body.appendChild(pop);pop.classList.add('ln24f-sheet');document.body.classList.add('ln24f-sheet-open');}}});
    pop._home=wrap;
    pop.addEventListener('click',function(e){e.stopPropagation();});
    wrap.appendChild(btn);wrap.appendChild(pop);
    return {wrap:wrap,btn:btn,pop:pop};
  }
  function closeAll(){document.querySelectorAll('.ln24f-sheet').forEach(function(p){p.classList.remove('ln24f-sheet');if(p._home)p._home.appendChild(p);});document.body.classList.remove('ln24f-sheet-open');document.querySelectorAll('.ln24f-dd.open').forEach(function(d){d.classList.remove('open');d.querySelector('.ln24f-btn').setAttribute('aria-expanded','false');});}
  document.addEventListener('click',closeAll);
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeAll();});

  function build(){
    var sb=$('ln24b-sidebar'),layout=document.querySelector('#ln24-browse .ln24b-layout'),pp=$('ln24b-price-pills'),pat=$('ln24b-pattern-pills'),cats=$('ln24b-categories'),sortSel=$('ln24b-sort'),count=$('ln24b-count');
    if(!sb||!layout||!pp||!pat||!sortSel||!count)return false;

    /* Price: buckets are what the customer actually pays (after 20% off); API filters on full price */
    pp.innerHTML=PRICES.map(function(r){return '<button type="button" class="ln24b-pill" data-range="'+r[0]+'">'+r[1]+'</button>';}).join('');
    pp.querySelectorAll('.ln24b-pill').forEach(function(b){b.classList.toggle('active',b.getAttribute('data-range')===window.ln24bActivePrice);b.addEventListener('click',function(){window.ln24bSetPrice(b.getAttribute('data-range'));closeAll();});});
    if(!sortSel.querySelector('option[value=lucky]')){var o=document.createElement('option');o.value='lucky';o.textContent='Luckiest first';sortSel.appendChild(o);}

    var bar=el('div','ln24f-bar');bar.id='ln24f-bar';
    var dP=dropdown('price','💰','Price');
    dP.pop.appendChild(el('div','ln24f-h','What you pay'));dP.pop.appendChild(pp);
    dP.pop.appendChild(el('p','ln24f-note','Searches all live inventory, 20% off already applied.'));
    var dT=dropdown('pattern','✨','Pattern');
    if(cats){dT.pop.appendChild(el('div','ln24f-h','Search for'));dT.pop.appendChild(cats);cats.querySelectorAll('.ln24b-cat-pill').forEach(function(b){b.addEventListener('click',closeAll);});}
    dT.pop.appendChild(el('div','ln24f-h','In these results'));dT.pop.appendChild(pat);
    var good=el('button','ln24f-btn ln24f-good','<span class="ic">🔮</span><span class="lb">Good sum only</span><i class="ct"></i>');good.type='button';
    good.addEventListener('click',function(e){e.stopPropagation();closeAll();S.good=!S.good;window.ln24bRender();});
    var dS=dropdown('sort','↕️','Sort');
    var list=el('div','ln24f-list');
    SORTS.forEach(function(s){var b=el('button','ln24f-row','<span class="ck">✓</span>'+s[1]);b.type='button';b.setAttribute('data-v',s[0]);b.addEventListener('click',function(){sortSel.value=s[0];closeAll();window.ln24bRender();});list.appendChild(b);});
    dS.pop.appendChild(list);
    count.classList.add('ln24f-count');
    var clr=el('button','ln24f-clear','Clear all');clr.type='button';clr.addEventListener('click',function(){window.ln24bClearFilters();});
    [dP.wrap,dT.wrap,good,dS.wrap,count,clr].forEach(function(n){bar.appendChild(n);});
    var chips=el('div','ln24f-chips');chips.id='ln24f-chips';
    layout.parentNode.insertBefore(bar,layout);layout.parentNode.insertBefore(chips,layout);
    sb.parentNode.removeChild(sb);
    var bd=$('ln24b-backdrop');if(bd)bd.parentNode.removeChild(bd);
    S.btn={price:dP.btn,pattern:dT.btn,sort:dS.btn,good:good,clear:clr,list:list};
    S.ready=true;return true;
  }

  function chip(label,fn){var c=el('span','ln24f-chip');c.appendChild(document.createTextNode(label));var x=el('button',null,'✕');x.type='button';x.setAttribute('aria-label','Remove '+label);x.addEventListener('click',fn);c.appendChild(x);return c;}
  function selText(id){var s=$(id);return s&&s.value?s.options[s.selectedIndex].text:'';}

  function refresh(){
    if(!S.ready)return;
    var all=live(),B=S.btn;
    /* pattern counts from loaded results */
    document.querySelectorAll('#ln24b-pattern-pills .ln24b-pill').forEach(function(p){
      var tag=p.getAttribute('data-tag');var n=all.filter(function(x){return x.pattern_tags.indexOf(tag)>-1&&(!S.good||x.good);}).length;
      var act=(window.ln24bActivePatterns||[]).indexOf(tag)>-1;
      p.innerHTML=(PAT_LABEL[tag]||tag)+' <i>'+n+'</i>';p.disabled=(n===0&&!act);
    });
    var goodN=all.filter(function(x){return x.good;}).length;
    B.good.querySelector('.ct').textContent=goodN;B.good.classList.toggle('on',S.good);
    var price=window.ln24bActivePrice,pl=PRICES.filter(function(r){return r[0]===price;})[0];
    B.price.querySelector('.lb').textContent=pl?pl[1]:'Price';B.price.classList.toggle('on',!!pl);
    var pats=window.ln24bActivePatterns||[],cat=window.ln24bActiveCategory||'all';
    var pn=pats.length+(cat!=='all'?1:0);
    B.pattern.querySelector('.lb').textContent=pn?('Pattern · '+pn):'Pattern';B.pattern.classList.toggle('on',pn>0);
    var sv=$('ln24b-sort').value,sl=SORTS.filter(function(s){return s[0]===sv;})[0];
    B.sort.querySelector('.lb').textContent=sl&&sv!=='recommended'?sl[1]:'Sort';B.sort.classList.toggle('on',sv!=='recommended');
    B.list.querySelectorAll('.ln24f-row').forEach(function(r){r.classList.toggle('on',r.getAttribute('data-v')===sv);});
    /* active chips */
    var box=$('ln24f-chips');box.innerHTML='';
    var st=selText('ln24b-ss-state');if(st)box.appendChild(chip('📍 '+st,function(){$('ln24b-ss-state').value='';window.ln24bOnStateChange();}));
    var ac=$('ln24b-ss-area').value;if(ac)box.appendChild(chip('☎️ Area '+ac,function(){$('ln24b-ss-area').value='';window.ln24bSearch();}));
    var q=($('ln24b-ss-pattern').value||'').trim();if(q)box.appendChild(chip('🔎 “'+q+'”',function(){$('ln24b-ss-pattern').value='';window.ln24bSearch();}));
    if(cat!=='all'){var cl=cat==='premium'?'Premium':cat;box.appendChild(chip('✨ '+cl,function(){window.ln24bSetCategory('all');}));}
    if(pl)box.appendChild(chip('💰 '+pl[1],function(){window.ln24bSetPrice(price);}));
    pats.forEach(function(t){box.appendChild(chip('✨ '+(PAT_LABEL[t]||t),function(){window.ln24bTogglePattern(t);}));});
    if(S.good)box.appendChild(chip('🔮 Good sum only',function(){S.good=false;window.ln24bRender();}));
    var ce=$('ln24b-count'),m=ce.textContent.match(/^(\d+) \/ (.+)$/);if(m)ce.textContent='Showing '+m[1]+' of '+m[2]+' numbers';
    B.clear.style.display=box.children.length?'':'none';
    box.style.display=box.children.length?'':'none';
  }

  function hook(){
    var oMap=window.ln24bMapItem,oSort=window.ln24bSortData,oRender=window.ln24bRender,oClear=window.ln24bClearFilters,oTog=window.ln24bTogglePattern;
    if(!oMap||!oRender)return false;
    window.ln24bMapItem=function(n){var o=oMap(n);o.good=!!n.goodSum;o.lucky=n.luckyScore||0;return o;};
    window.ln24bSortData=function(arr){if($('ln24b-sort').value==='lucky'){return arr.slice().sort(function(a,b){return (b.good-a.good)||(b.lucky-a.lucky)||(a.price-b.price);});}return oSort(arr);};
    window.ln24bRender=function(state){
      if(state){oRender(state);refresh();return;}
      var all=window.LN24B_LIVE;
      if(S.good)window.LN24B_LIVE=all.filter(function(x){return x.good;});
      try{oRender();}finally{window.LN24B_LIVE=all;}
      refresh();
    };
    window.ln24bClearFilters=function(){S.good=false;$('ln24b-sort').value='recommended';oClear();};
    window.ln24bTogglePattern=function(t){oTog(t);};
    window.ln24bToggleDrawer=function(){};
    /* results that loaded before this script ran lack the good-sum data: reload once */
    var L=live();if(L.length&&L[0].good===undefined){window.ln24bFetchLive();}
    return true;
  }

  function start(){if(!build()||!hook()){return setTimeout(start,60);}refresh();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
